<template>
  <div class="selectDealerBox">
    <div class="header">
      <div class="fvlr">
        <div></div>
        <div>请选择经销商</div>
        <div @click="close">
          <van-icon name="cross" />
        </div>
      </div>
      <!-- {{ position }} -->
      <div v-if="fromTyre">
        <div class="currentAdressFlag">当前位置</div>
        <div class="fvlr currentAdress">
          {{ formattedAddress || '定位失败' }}
          <span class="fvl" @click="relocation">
            <van-loading v-if="showLoading" class="address" color="#1989fa" size="14" />
            <img v-else src="../../assets/images/address.svg" class="cb" />
            重新定位
          </span>
        </div>
      </div>
      <div class="fvl searchBox">
        <div class="fvl" @click="selectCityFn">
          <van-icon size="20px" color="#3088c5" name="location-o" />
          <div class="result">{{ result.name || result.provinceInfo || result }}</div>
        </div>
        <!-- <van-search v-model="searchVal" @update:model-value="onSearch" placeholder="请输入经销商名称或地址" /> -->
        <van-field class="mySearch" clearable v-model="searchVal" @update:model-value="onSearch" left-icon="search" placeholder="请输入经销商名称或地址" />
      </div>
      <van-tabs v-show="fromTyre" v-model:active="activeName">
        <van-tab title="按距离排序" name="distance"></van-tab>
        <van-tab title="按销量排序" name="sales"></van-tab>
      </van-tabs>
    </div>
    <div class="selectDealer" :class="{ tyreSelectDealer: fromTyre }">
      <ul v-if="list.length">
        <li class="fvlr" :class="{ currentDealer: getDealerActive(item) }" v-for="item in list" :key="item.id" @click="selectFn(item)">
          <van-row gutter="8" justify="space-between">
            <van-col span="17">
              <div class="fhl left">
                <div class="fw">{{ item.name }}</div>
                <div class="bottom addressBox ellipsis ">
                  {{ item.address }}
                </div>
              </div>
            </van-col>
            <van-col span="6">
              <div class="activeWrap right">
                <div class="distance">
                  {{ item.distance || item.distance === 0 ? item.distance + 'km' : '定位失败' }}
                </div>
                <div v-if="fromTyre" class="sales">销量： {{ item.sales }}</div>
                <div
                  v-else-if="from === 'coupon'"
                  class="bottom activeBox"
                  :class="{
                    active: item.joinCouponFlag,
                    hidden: !Reflect.has(item, 'joinCouponFlag')
                  }"
                >
                  {{ item.joinCouponFlag ? '' : '未' }}参加活动
                </div>
                <div
                  v-else
                  class="bottom activeBox"
                  :class="{
                    active: item.joinPlanFlag,
                    hidden: !Reflect.has(item, 'joinPlanFlag')
                  }"
                >
                  {{ item.joinPlanFlag ? '' : '未' }}参加活动
                </div>
                <div v-if="isShowPhone" class="phoneBox" @click.stop>
                  <a :href="`tel:${item.tel}`">
                    <van-icon class="phone" name="phone" size="20" color="#3088c5" />
                  </a>
                </div>
              </div>
            </van-col>
          </van-row>
        </li>
      </ul>
      <div class="fc nodata" v-else>
        {{ fromTyre && !hasPosition && activeName === 'distance' ? '请开启定位功能' : '没有搜索到相应经销商' }}
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watch, onUnmounted, computed, nextTick } from 'vue'
import { getDealers } from '@/api/plan'
import { getOabDealer } from '@/api/oab'
import { getShopListDealer, getShopDealerListBySku, getEWShopDealerListBySpu } from '@/api/directSales'
import { getCommodities } from '@/api/tyre'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { getTyreDealer } from '@/util/tyreList'
import { getDefaultCityId } from '@/util/city'
import { getDistance } from '@/util'
import { showToast } from '@/util/couponCollection'
import useCurrentCarInfo from '@/hooks/directSales/useCurrentCarInfo'
import _ from 'lodash'
export default {
  name: 'selectDealer',
  props: ['selectCity', 'showNum', 'fromTyre', 'isShowPhone', 'from'],
  setup(props, { emit }) {
    const store = useStore()
    let { selectCity, showNum, fromTyre, isShowPhone, from } = toRefs(props)
    let { path } = useRoute()
    let { formattedAddress, currentGoodsInfo, locationInfo, currentCity, dealerInfo } = store.state
    let { loyaltyId } = currentGoodsInfo
    let { position } = store.state
    const { carInfo } = useCurrentCarInfo()
    const state = reactive({
      active: 0,
      position,
      searchVal: '',
      result: selectCity.value || currentCity || (locationInfo && locationInfo.city),
      searchQuery: '',
      list: [],
      listByDistance: [],
      listBySales: [],
      allList: [],
      ProvinceCity: [],
      loyaltyId,
      currentDealer: loyaltyId ? dealerInfo : {},
      fromTyre,
      from,
      isShowPhone,
      formattedAddress,
      activeName: 'distance',
      showLoading: false,
      hasPosition: true,
      Reflect
    })
    let address = computed(() => {
      return store.state.formattedAddress
    })
    let city = computed(() => {
      let { locationInfo, currentCity } = store.state
      return selectCity.value || currentCity || (locationInfo && locationInfo.city)
    })
    let getDealerActive = item => {
      let idBool = state.currentDealer.id === item.id
      let _gsCode = state.currentDealer.gs_code || state.currentDealer.gsCode
      let gsCodeBool = _gsCode === item.gsCode
      return idBool || gsCodeBool
    }
    let getDealersFn = async val => {
      let { position, couponId } = store.state
      let { lat, lng } = position
      let dearParams = {
        cityName: state.result.name || state.result,
        keyword: val,
        latitude: lat,
        longitude: lng,
        loyaltyId: (path !== '/planList' && state.loyaltyId) || '',
        pageNo: '1',
        pageSize: '10000'
      }
      if (couponId || state.from === 'coupon') {
        dearParams.couponId = couponId
        dearParams.loyaltyId = ''
      }
      let { list } = await getDealers(dearParams)
      if (dearParams.loyaltyId || dearParams.couponId) {
        // LPO-5126-计划详情，“参加活动"的经销商置顶展示
        let joinRes = [],
          otherRes = []
        for (let index = 0, len = list.length; index < len; index++) {
          const element = list[index]
          let sortKey = dearParams.loyaltyId ? 'joinPlanFlag' : 'joinCouponFlag'
          if (element[sortKey] === 1) {
            joinRes.push(element)
          } else {
            otherRes.push(element)
          }
        }
        list = [...joinRes, ...otherRes]
      }
      state.list = state.allList = getDistanceFn(list)
    }
    const getDistanceFn = list => {
      list.map(item => {
        item.distance = getDistance(item.distance, state.from === 'ewShopDetail')
        let _gsCode = item.gs_code || item.gsCode
        item.gs_code = item.gsCode = _gsCode
        return item
      })
      return list
    }
    let getTyreDealerList = async val => {
      let { currentCity, currentTyre, position } = store.state
      let { lat, lng } = position
      let cityId = ''
      if (!currentCity.id) {
        cityId = await getDefaultCityId()
      }
      let params = {
        keyword: val,
        tyreId: currentTyre.id,
        cityId: currentCity.id || cityId,
        latitude: lat,
        longitude: lng
      }
      try {
        let { list = [] } = await getCommodities(params)
        if (!list) {
          state.listBySales = state.listByDistance = state.list = []
          return
        }
        let listData = await getTyreDealer(list)
        // 按销量降序
        state.listBySales = _.orderBy(listData, ['sales'], ['desc'])
        // 按距离升序
        state.listByDistance = _.sortBy(listData, item => item.distance)
        if (!lat && !lng) {
          state.activeName = 'sales'
          state.list = state.listBySales
          state.listByDistance = []
          state.hasPosition = false
        } else {
          state.list = state.listByDistance
          state.hasPosition = true
        }
      } catch (e) {
        console.log(e)
        state.hasPosition = true
      }
    }
    let getOabDealerList = async val => {
      let { lat: latitude, lng: longitude } = store.state?.position
      // let { currentCity } = store.state
      // let cityId = ''
      // if (!currentCity.id) {
      //   cityId = await getDefaultCityId()
      // }
      // let cityName = currentCity.id || cityId
      let keyWord = val ? _.trim(val) : ''
      let cityName = state.result.name || state.result
      let params = {
        city: cityName,
        carId: store.state?.carId || '',
        latitude,
        longitude
      }
      // console.log('getOabDealerList-->', params)
      try {
        let list = await getOabDealer(params)
        let tempList = getDistanceFn(list)
        if (keyWord) {
          state.list = tempList.filter(item => item.name.search(keyWord) != -1)
        } else {
          state.list = tempList
        }
      } catch (e) {
        console.error(e)
        state.list = []
      }
    }
    let getBasicDealerList = async val => {
      let { position } = store.state
      let { lat, lng } = position
      let dearParams = {
        cityName: state.result.name || state.result,
        keyword: val,
        latitude: lat,
        longitude: lng,
        pageNo: '1',
        pageSize: '10000'
      }
      let { list } = await getDealers(dearParams)
      state.list = state.allList = getDistanceFn(list)
    }
    let getShopListDealerFn = async val => {
      let { position } = store.state
      let { lat, lng } = position
      let dearParams = {
        cityName: state.result.name || state.result,
        keyword: val,
        latitude: lat,
        longitude: lng,
        pageNo: '1',
        pageSize: '10000'
      }
      try {
        let { list } = await getShopListDealer(dearParams)
        state.list = state.allList = getDistanceFn(list)
      } catch (error) {
        state.list = []
      }
    }
    let getShopDetailDealerFn = async val => {
      // console.log('getShopDetailDealerFn-----获取销售经销商列表-')
      let { position, skuItem, spuId } = store.state
      let { lat, lng } = position
      let dearParams = {
        cityName: state.result.name || state.result,
        spuId,
        keyword: val,
        latitude: lat,
        longitude: lng,
        pageNo: '1',
        pageSize: '10000'
      }
      // if (!skuItem || !skuItem?.skuId) {
      //   state.list = state.allList = []
      //   // store.dispatch('setLoyaltyDealerInfo', {})
      //   // return
      //   dearParams.skuId = -1
      // }
      try {
        let { records: list = [] } = await getShopDealerListBySku(dearParams)
        state.list = state.allList = getDistanceFn(list)
        if (list.length === 0) {
          store.dispatch('setLoyaltyDealerInfo', {})
        } else {
          let loyaltyDealerInfo = store.state.loyaltyDealerInfo
          let gsCode = loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_gode
          let current = list.find(item => {
            let itemGscode = item.gsCode || item.gs_gode
            return itemGscode === gsCode
          })
          !current && store.dispatch('setLoyaltyDealerInfo', {})
        }
      } catch (error) {
        state.list = state.allList = []
        store.dispatch('setLoyaltyDealerInfo', {})
        showToast(error.message, '获取销售经销商列表失败')
      }
    }

    const getEWShopDetailDealerFn = async val => {
      try {
        const { position, spuId } = store.state
        const { lat, lng } = position
        const list = await getEWShopDealerListBySpu(spuId, {
          cityName: state.result.name || state.result,
          spuId,
          keyword: val,
          latitude: lat,
          longitude: lng,
          fin: carInfo._object?.carInfo?.fin
        })
        state.list = state.allList = getDistanceFn(list)
        if (list.length === 0) {
          store.dispatch('setLoyaltyDealerInfo', {})
        } else {
          let loyaltyDealerInfo = store.state.loyaltyDealerInfo
          let gsCode = loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_gode
          let current = list.find(item => {
            let itemGscode = item.gsCode || item.gs_gode
            return itemGscode === gsCode
          })
          !current && store.dispatch('setLoyaltyDealerInfo', {})
        }
      } catch (error) {
        state.list = state.allList = []
        store.dispatch('setLoyaltyDealerInfo', {})
        showToast(error.message, '获取销售经销商列表失败')
      }
    }

    const handleGetDealerList = v => {
      if (state.fromTyre) {
        getTyreDealerList(v)
      } else if (state.from === 'oab') {
        getOabDealerList(v)
      } else if (state.from === 'shopList') {
        getShopListDealerFn(v)
      } else if (state.from === 'completeInfo') {
        getBasicDealerList(v)
      } else if (state.from === 'shopDetail') {
        getShopDetailDealerFn(v)
      } else if (state.from === 'ewShopDetail') {
        getEWShopDetailDealerFn(v)
      } else {
        getDealersFn(v)
      }
    }
    watch(
      () => selectCity.value,
      n => {
        state.result = n
        state.searchVal = ''
        handleGetDealerList()
      }
    )
    watch(
      () => showNum.value,
      () => {
        let { loyaltyId } = store.state.currentGoodsInfo
        state.currentDealer = store.state.dealerInfo
        state.loyaltyId = loyaltyId
        nextTick(() => {
          const needRefreshList = ['shopDetail', 'ewShopDetail']
          console.log('经销商弹出刷新----------------')
          if (needRefreshList.includes(state.from)) {
            state.list = []
            handleGetDealerList()
          }
        })
      }
    )

    watch(
      () => store.state.position,
      () => {
        state.fromTyre && getTyreDealerList()
      }
    )
    watch(
      () => store.state.formattedAddress,
      n => {
        state.formattedAddress = n
        state.showLoading = false
      }
    )
    watch(
      () => state.activeName,
      n => {
        state.list = n === 'distance' ? state.listByDistance : state.listBySales
      }
    )
    watch(
      () => store.state.carId,
      (n, o) => {
        if (n !== o) getOabDealerList()
      }
    )
    let onSearch = _.debounce(async val => {
      handleGetDealerList(val)
    }, 200)
    let relocation = () => {
      state.showLoading = true
      store.dispatch('getLocation')
      setTimeout(() => {
        state.showLoading = false
      }, 5000)
    }
    let selectCityFn = () => {
      emit('selectCityFn')
    }
    let close = () => {
      emit('selectResultFn')
    }
    let selectFn = item => {
      if (Reflect.has(item, 'joinPlanFlag') && !item.joinPlanFlag) return
      emit('selectResultFn', item)
    }
    onMounted(async () => {
      state.result = city.value
      state.formattedAddress = address.value
      handleGetDealerList()
    })
    onUnmounted(() => {
      onSearch.cancel()
    })
    return {
      ...toRefs(state),
      close,
      selectFn,
      onSearch,
      selectCityFn,
      relocation,
      getDealerActive
    }
  }
}
</script>

<style lang="scss" scoped>
.nodata {
  margin-top: 65px;
}
.cb {
  width: 15px;
  height: 15px;
  margin-right: 4px;
}
.address {
  margin-right: 5px;
}
.currentAdressFlag {
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
}
.currentAdress {
  font-size: 14px;
  color: #333333;
  span {
    font-size: 12px;
    color: #666;
  }
}
.selectDealerBox {
  height: 100%;
  position: relative;
  text-align: left;
  .selectDealer {
    width: 100%;
    padding: 104px 22px 0;
    position: absolute;
    top: 50px;
    margin-top: -50px;
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
    .right {
      text-align: center;
    }
    .distance {
      line-height: 1.6;
    }
  }
  .tyreSelectDealer {
    padding-top: 191px;
    ul {
      margin-top: 20px;
    }
  }
  .header {
    font-size: 15px;
    padding: 15px 22px;
    font-weight: bold;
    position: absolute;
    top: 0;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    z-index: 10;
  }
  .searchBox {
    font-size: 14px;
  }
  .result {
    width: 60px;
    margin-left: 5px;
  }
  .van-search {
    padding-right: 0;
    width: 100%;
    font-size: 12px;
  }
  .van-field__control {
    width: 200px;
  }
  li {
    padding: 16px 0;
    border-bottom: 1px solid rgb(238, 238, 238);
    > div {
      width: 100%;
    }
  }
  .left {
    text-align: left;
  }
  .bottom {
    margin-top: 9px;
  }
  .activeBox {
    padding: 2px 5px;
    border-radius: 18px;
    border: 1px solid #666666;
  }
  .addressBox {
    width: 100%;
    color: #666666;
  }
  .active {
    color: #3088c5;
    border-color: #3088c5;
  }
  .currentDealer div {
    color: #3088c5;
    .activeBox {
      border-color: #3088c5;
    }
  }
  .hidden {
    // visibility: hidden;
    display: none;
  }
  .activeWrap {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
.fw {
  color: #333333;
  font-size: 14px;
}
.sales {
  font-size: 0.34667rem;
  color: #3088c5;
  margin-top: 10px;
}
.phoneBox {
  display: inline-block;
  width: 30px;
  height: 26px;
  transform: rotate(-90deg);
  vertical-align: bottom;
}
:deep(.van-tabs__line) {
  width: 98px;
  background-color: #3088c5;
}
:deep(.van-tab--active) {
  color: #3088c5;
  font-size: 14px;
  font-weight: 600;
}
</style>
